/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ProgressBar/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function ProgressBar({
  children,
  viewPath = "/App/Widget/Content/Questions/Review/Progress/ProgressBarIndicator/ProgressBar"
  
}) {
  let isBefore = useIsBefore()
  let isMedia = useIsMedia()
let dtProgressbarBordercolorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'ProgressBar.borderColor.primary.base'
        })
let selectedFlowQuestionsValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'flowQuestions',
})
let selectedAnswersValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'answers',
})
let aggregateData = fromHelpers.getCurrentProgress(selectedFlowQuestionsValueData, selectedAnswersValueData)
let dtProgressbarBackgroundcolorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'ProgressBar.backgroundColor.primary.base'
        })
  return (<React.Fragment
>
<div
  data-testid="ProgressBar.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-Z1L134q': dtProgressbarBordercolorPrimaryBase,'--w-2-Z1L134q': isMedia.mobile ? "75%" : "85%"}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="ProgressBar.Horizontal"
  data-view-path={viewPath}
 style={{'--bc-3-Z1L134q': dtProgressbarBackgroundcolorPrimaryBase,'--w-2-Z1L134q': typeof aggregateData === 'number' ? `${aggregateData}px` : aggregateData,'--o-4-Z1L134q': isBefore ? 0 : 1}}
 className={`views-block ${styles.Horizontal}`}
/>
</div>
{children}
</React.Fragment>)
}